// Cloudinary upload utility
// Free tier: 25GB storage, automatic optimization

export async function uploadToCloudinary(file) {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  if (!cloudName || !uploadPreset) {
    // Dev mode — return a fake URL
    return {
      success: true,
      url: URL.createObjectURL(file),
      devMode: true,
    };
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);
  formData.append('folder', 'makayla-portfolio');

  try {
    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`,
      { method: 'POST', body: formData }
    );
    const data = await res.json();
    if (data.secure_url) {
      return { success: true, url: data.secure_url };
    }
    throw new Error(data.error?.message || 'Upload failed');
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// Detect embed type from URL
export function detectMediaType(url) {
  if (!url) return 'image';
  if (url.includes('youtube.com') || url.includes('youtu.be')) return 'youtube';
  if (url.includes('vimeo.com')) return 'vimeo';
  if (url.includes('tiktok.com')) return 'tiktok';
  if (url.includes('instagram.com')) return 'instagram';
  if (url.includes('facebook.com')) return 'facebook';
  if (url.includes('linkedin.com')) return 'linkedin';
  return 'video';
}

// Get LinkedIn embed URL from a post/feed URL (activity, share, or ugcPost)
export function getLinkedInEmbedUrl(url) {
  if (!url) return null;
  let urn = null;
  let match = url.match(/urn:li:(?:activity|share|ugcPost):(\d+)/);
  if (match) {
    urn = `urn:li:activity:${match[1]}`;
  } else {
    match = url.match(/activity-(\d+)/);
    if (match) urn = `urn:li:activity:${match[1]}`;
  }
  return urn ? `https://www.linkedin.com/embed/feed/update/${urn}` : null;
}

// Get YouTube embed URL from any YouTube URL format
export function getYouTubeEmbedUrl(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  const id = match && match[2].length === 11 ? match[2] : null;
  return id ? `https://www.youtube.com/embed/${id}` : null;
}

// Get Vimeo embed URL
export function getVimeoEmbedUrl(url) {
  const match = url.match(/vimeo\.com\/(\d+)/);
  return match ? `https://player.vimeo.com/video/${match[1]}` : null;
}
